import React from 'react';
import useSessionStoreContext from '../Contexts/SessionStoreContextProvider/useSessionStoreContext';
import useAudioServerCommunication from './useAudioServerCommunication';

export default function useStopSession() {
  const { sessionId: [sessionId], terminating: [, setTerminating] } = useSessionStoreContext();
  const { sendJsonMessage } = useAudioServerCommunication();
  const stopSession = React.useCallback((endCause: string) => {
    switch (endCause) {
      case 'ProjectChanged':
      case 'LanguageChanged':
        break;
      default:
        setTerminating(sessionId);
        break;
    }
    sendJsonMessage({
      type: 'endSession',
      cause: endCause,
      date: Date.now() * 1e6,
    });
  }, [sessionId]);

  return stopSession;
}
